module.exports = __webpack_public_path__ + "905a93d2144523ee7bb9c3843980823a.svg";